import config from 'root/common/config/config';

let urls = {
    sendSms: '/common/send-sms-captcha',
    gtInit: '/gt/register-slide',
    registerByPhone: '/share/register-by-phone',
    getEntry: '/advertise/get-entry',
    getShareIcon: `${config.privilegeApiDomain}/share/getShareIcon`,
    getShareInfo: `${config.privilegeApiDomain}/share/getShareInfo`,
};

export default urls;
